import * as Output from "../../Text";
import { Rules } from '../technical';

const majoritySelected = (isMajorityShareholder: "yes" | "no") =>
  isMajorityShareholder === "yes";

export const majorityShareholderCompaniesNameValidation = (field: string, fields: { isMajorityShareholder: "yes" | "no" }) =>
  majoritySelected(fields.isMajorityShareholder) &&
    (!field || field.length === 0)
    ? Output.resolve("generic.errors.M001_mandatoryFields")
    : Rules.maxLength(50)(field);

export const majorityShareholderCompaniesCityValidation = (field: string, fields: { isMajorityShareholder: "yes" | "no" }) =>
  majoritySelected(fields.isMajorityShareholder) &&
    (!field || field.length === 0)
    ? Output.resolve("generic.errors.M001_mandatoryFields")
    : Rules.maxLength(50)(field);